import { store } from "../main"

export function consoleMessage(...args) {
  if (store.getters.afficherLogsConsole)
    console.log(...args)
}